import React from "react";
import get from "lodash/get";

import StarRating from "../../../atoms/star-rating";

import "./movie-review.m.css";

const MovieReviewView = ({ story }) => {
  const MetaData = get(story, ["metadata"]);
  const movieName = get(MetaData, ["movie-name"], "");
  const movieCast = get(MetaData, ["movie-casting"], "");
  const movieDirector = get(MetaData, ["movie-director"], "");
  const musicDirector = get(MetaData, ["music-director"], "");
  const rating = get(MetaData, ["movie-rating"], "");
  const movieDate = get(MetaData, ["movie-date-and-duration"], "");

  const moviehour = movieDate.split(" ");
  let year = moviehour[0];
  let duration = moviehour[1];

  if (
    movieName === "" &&
    movieCast == "" &&
    movieDate == "" &&
    rating == "" &&
    movieDirector === "" &&
    musicDirector === ""
  ) {
    return null;
  }

  return (
    <div styleName="wrapper">
      <div styleName="text-and-rating">
        <div styleName="title-wrapper">
          {movieName.length > 0 && <div styleName="title">ಚಿತ್ರ ವಿಮರ್ಶೆ : {movieName}</div>}
          {movieDate.length > 0 && (
            <div styleName="date">
              <span styleName="year">{year}</span>
              <span styleName="dot" />
              <span styleName="duration">{duration}</span>
            </div>
          )}
        </div>
        {rating.length > 0 && <StarRating rating={rating} />}
      </div>
      {movieDirector.length > 0 && (
        <div styleName="details">
          <span styleName="entity-name">ನಿರ್ದೇಶನ:</span>
          <span styleName="entity-value">{movieDirector}</span>
        </div>
      )}
      {movieCast.length > 0 && (
        <div styleName="details">
          <span styleName="entity-name">ಪಾತ್ರವರ್ಗ:</span>
          <span styleName="entity-value">{movieCast}</span>
        </div>
      )}
      {musicDirector.length > 0 && (
        <div styleName="details">
          <span styleName="entity-name">ಸಂಗೀತ ನಿರ್ದೇಶಕ:</span>
          <span styleName="entity-value">{musicDirector}</span>
        </div>
      )}
    </div>
  );
};

export default MovieReviewView;
